<template>
  <div class="brachistochrone-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>摆线 是最短时间路径</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <text x="20" y="30" fill="#fff" font-size="10">起点 A</text>
          <text x="350" y="210" fill="#fff" font-size="10">终点 B</text>

          <!-- Paths -->
          <path d="M 50,40 L 350,200" fill="none" stroke="#555" stroke-dasharray="4" /> <!-- Straight -->
          <path d="M 50,40 Q 50,200 350,200" fill="none" stroke="#555" stroke-dasharray="4" /> <!-- Circular/Quadratic -->
          <path :d="cycloidPath" fill="none" stroke="#ffd700" stroke-width="2" /> <!-- Cycloid -->

          <!-- Balls -->
          <circle :cx="ballStraight.x" :cy="ballStraight.y" r="5" fill="#888" />
          <circle :cx="ballCycloid.x" :cy="ballCycloid.y" r="6" fill="#ffd700" />
          
          <text x="300" y="50" fill="#888" font-size="8">直线路径</text>
          <text x="200" y="160" fill="#ffd700" font-size="8">最速降线 (摆线)</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <el-button type="primary" size="mini" @click="race">开始比赛</el-button>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>给定不垂直的两个点 A 和 B，哪条轨道能让物体在重力作用下最快到达？常识可能认为是直线，但实际是**摆线**。这是因为摆线让物体在起始阶段获得最大的加速度，从而全程平均速度更高。这一著名的牛顿和莱布尼茨时代的难题，催生了数学中的**变分法**。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrachistochroneCurveViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      progress: 0,
      animating: false,
      timer: null
    }
  },
  computed: {
    cycloidPath() {
       // Mock cycloid between (50,40) and (350,200)
       return "M 50,40 C 60,180 180,210 350,200";
    },
    ballStraight() {
       let p = this.progress;
       return { x: 50 + p * 300, y: 40 + p * 160 };
    },
    ballCycloid() {
       let p = Math.pow(this.progress, 0.7); // Accelerates faster
       if (p > 1) p = 1;
       // Approximate bezier pos
       let cx1 = 60, cy1 = 180, cx2 = 180, cy2 = 210;
       let x1 = 50, y1 = 40, x2 = 350, y2 = 200;
       let x = Math.pow(1-p, 3)*x1 + 3*Math.pow(1-p, 2)*p*cx1 + 3*(1-p)*p*p*cx2 + p*p*p*x2;
       let y = Math.pow(1-p, 3)*y1 + 3*Math.pow(1-p, 2)*p*cy1 + 3*(1-p)*p*p*cy2 + p*p*p*y2;
       return { x, y };
    }
  },
  methods: {
    race() {
       this.progress = 0;
       this.animating = true;
       this.update();
    },
    update() {
       if (!this.animating) return;
       this.progress += 0.01;
       if (this.progress >= 1) {
          this.progress = 1;
          this.animating = false;
       } else {
          this.timer = requestAnimationFrame(this.update);
       }
    }
  },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.brachistochrone-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
